export default __webpack_public_path__ + "static/media/sp2.6394e4e4.jpeg";